import { lazy } from 'react';

const ApprovalList = lazy(() => import('../pages/ApprovalList'));
const ProcessList = lazy(() => import('../pages/Approval/List'));
const Approval = lazy(() => import('../pages/Approval/Create'));
const SettleConfig = lazy(() => import('../pages/SettleConfig'));
const OrderDetailNew = lazy(() => import('../pages/OrderDetailNew/index'));
const AccountSettings = lazy(() => import('../pages/AccountSettings'));
const BindingEmail = lazy(() => import('../pages/AccountSettings/components/BindingEmail'));
const ActivityPage = lazy(() => import('../pages/ActivityPage'));
const EditProcess = lazy(() => import('../pages/EditProcess/index'));
const TaskCenter = lazy(() => import('../pages/TaskCenter/index'));
const ApplyAfterSale = lazy(() => import('../pages/AfterSale/ApplyAfterSale'));
const AfterSaleDetail = lazy(() => import('../pages/AfterSale/Detail'));
const AddressList = lazy(() => import('../pages/AddressList'));
const AddressAuthority = lazy(() => import('../pages/AddressAuthority'));
const MaterialCode = lazy(() => import('../pages/MaterialCode'));
const CustomerRegistration = lazy(() => import('@/pages/CustomerRegistration'));
const OrderList = lazy(() => import('../pages/OrderList'));
const Remittance = lazy(() => import('@/pages/Remittance'));
const IntentionList = lazy(() => import('../pages/IntentionList'));
const IntentionDetail = lazy(() => import('../pages/IntentionDetail'));
const InvoiceApplication = lazy(() => import('../pages/InvoiceApplication'));

export default [
  {
    path: `/orderList`,
    name: 'OrderList',
    meta: {
      title: 'orderList',
      pageId: 'OrderList',
    },
    exact: true,
    component: OrderList,
  },
  {
    path: `/invoice/application`,
    name: 'InvoiceApplication',
    meta: {
      title: 'invoiceApplication',
      pageId: 'InvoiceApplication',
    },
    exact: true,
    component: InvoiceApplication,
  },
  {
    path: `/intentionList`,
    name: 'IntentionList',
    meta: {
      title: 'intentionList',
      pageId: 'IntentionList',
    },
    exact: true,
    component: IntentionList,
  },
  {
    path: `/intention/detail`,
    name: 'IntentionDetail',
    meta: {
      title: 'intentionDetail',
      pageId: 'IntentionDetail',
    },
    exact: true,
    component: IntentionDetail,
  },
  //订单审批
  {
    path: `/Approval`,
    name: 'Approval',
    meta: {
      title: 'Approval', //审核订单
      pageId: 'Approval',
    },
    exact: true,
    component: Approval,
    params: {
      isAudit: true,
    },
  },
  //配置管理
  {
    path: `/settleConfig`,
    name: 'SettleConfig',
    meta: {
      title: 'settleConfig', //审核订单
      pageId: 'SettleConfig',
    },
    exact: true,
    component: SettleConfig,
    params: {
      isAudit: true,
    },
  },
  // 审核订单列表
  {
    path: `/approvalList`,
    name: 'ApprovalList',
    meta: {
      title: 'approvalList', //审核订单
      pageId: 'ApprovalList',
    },
    exact: true,
    component: ApprovalList,
    params: {
      isAudit: true,
    },
  },
  //地址管理
  {
    path: `/addressList`,
    name: 'AddressList',
    exact: true,
    meta: {
      title: 'addressList',
      pageId: 'AddAddress',
    },
    component: AddressList,
  },
  {
    path: `/authorityAddress`,
    name: 'authorityAddress',
    exact: true,
    meta: {
      title: 'authorityAddress',
      pageId: 'AddressAuthority',
    },
    component: AddressAuthority,
  },
  //物料编码管理
  {
    path: `/materialManage`,
    name: 'MaterialCode',
    exact: true,
    meta: {
      title: 'materialCode',
      pageId: 'MaterialManagement',
    },
    component: MaterialCode,
  },
  {
    path: `/authorityAddress`,
    name: 'authorityAddress',
    exact: true,
    meta: {
      title: 'authorityAddress',
      pageId: 'AddressAuthority',
    },
    component: AddressAuthority,
  },
  // 订单回收站
  {
    path: `/deleteOrderList`,
    name: 'DeleteOrderList',
    meta: {
      title: '订单回收站',
      pageId: 'DeleteOrderList',
    },
    exact: true,
    component: OrderList,
    params: {
      isDelete: true,
    },
  },
  // 批量下单批次查询
  {
    path: `/batchList`,
    name: 'BatchList',
    meta: {
      title: 'orderDetail',
      pageId: 'BatchOrderList',
    },
    exact: true,
    component: OrderList,
    params: {
      isBatch: true,
    },
  },
  // 订单详情
  {
    path: `/order/detail`,
    name: 'OrderDetailNew',
    meta: {
      title: 'orderDetail',
      pageId: 'OrderDetail',
    },
    exact: true,
    component: OrderDetailNew,
  },
  {
    path: `/accountSettings`,
    name: 'AccountSettings',
    exact: true,
    meta: {
      title: 'account',
      pageId: 'AccountManagement',
    },
    component: AccountSettings,
  },
  {
    path: `/bindingEmail`,
    name: 'BindingEmail',
    exact: true,
    meta: {
      title: '绑定邮箱',
      pageId: 'BindingEmail',
    },
    component: BindingEmail,
  },
  //流程管理
  {
    path: `/processList`,
    name: 'ProcessList',
    exact: true,
    meta: {
      title: 'approvalSettings',
      pageId: 'ProcessList',
    },
    component: ProcessList,
  },
  //编辑审批流
  {
    path: `/editProcess`,
    name: 'EditProcess',
    exact: true,
    meta: {
      title: 'editApprovalFlow',
      pageId: 'EditProcess',
    },
    component: EditProcess,
  },
  //创建审批流
  {
    path: `/createProcess`,
    name: 'CreateProcess',
    exact: true,
    meta: {
      title: 'createApprovalFlow',
      pageId: 'CreateProcess',
    },
    component: EditProcess,
  },
  {
    path: `/taskCenter`,
    name: 'taskCenter',
    exact: true,
    meta: {
      title: 'taskCenter',
      pageId: 'TaskCenter',
    },
    component: TaskCenter,
  },
  //售后
  {
    path: `/afterSale/apply`,
    name: 'AfterSale',
    exact: true,
    meta: {
      title: 'AfterSale',
      pageId: 'AfterSaleApply',
    },
    component: ApplyAfterSale,
  },
  {
    path: `/afterSale/detail`,
    name: 'AfterSale',
    exact: true,
    meta: {
      title: 'AfterSale',
      pageId: 'AfterSaleDetail',
    },
    component: AfterSaleDetail,
  },
  {
    path: `/activityPage`,
    name: 'activityPage',
    exact: true,
    meta: {
      title: 'activityPage',
      pageId: 'ActivityPage',
    },

    component: ActivityPage,
  },
  // {
  //   path: `/register/guide`,
  //   name: 'registerGuide',
  //   exact: true,
  //   meta: {
  //     title: 'RegisterGuide',
  //     pageId: 'RegisterGuide',
  //     simplePage: true
  //   },
  //   component: RegistrationGuide,
  // },
  // {
  //   path: `/register`,
  //   name: 'register',
  //   exact: true,
  //   meta: {
  //     title: 'Register',
  //     pageId: 'Register',
  //     simplePage: true
  //   },
  //   component: Registration,
  // },
  // {
  //   path: `/register/success`,
  //   name: 'registerSuccess',
  //   exact: true,
  //   meta: {
  //     title: 'RegisterSuccess',
  //     pageId: 'RegisterSuccess',
  //     simplePage: true
  //   },
  //   component: RegistrationSuccess,
  // },
  {
    path: `/customerregistration`,
    name: 'customerRegistration',
    exact: true,
    meta: {
      title: 'CustomerRegistration',
      // 此前误用活动页 pageId，登记提交会串到 ActivityPage
      pageId: 'CustomerRegistration',
    },
    component: CustomerRegistration,
  },
  {
    path: `/remittance`,
    name: 'remittance',
    exact: true,
    meta: {
      title: 'remittance',
      pageId: 'Remittance',
    },
    component: Remittance,
  },
];
